import React, { useContext } from "react";

import { WizardContext } from "../index";
import BoltOns from "./layouts/BoltOns";
import { useCoworkingTotal } from "../functions/coworking";

export default function StepTwo() {
  const { cart } = useContext(WizardContext);

  const total = useCoworkingTotal(cart);
  return (
    <div className="appStep2">
      <div className="stepContent">
        <div className="extraList">
          <BoltOns inCart={false} isDisplayCart={false} />
        </div>
        {total > 0 && (
          <div className="totalRow">
            <p>
              Prices are based on a cost per item per month.&nbsp;
              <br />
              Increase quantities to add per member.
            </p>
            <h3>
              Extras total: <b>£{total.toFixed(2)} &nbsp;/ month</b>
            </h3>
          </div>
        )}
      </div>
    </div>
  );
}
